import React from 'react';
import { CardTitle } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import {
  BACKGROUND_DARK,
  BORDER_DARK,
  DASHBOARD_BOX_SHADOW, GREY_COLOR,
  VERY_LIGHT_GREY_COLOR,
} from '../../../const/color-const';
import withStyles from '@material-ui/core/styles/withStyles';
import { CircularProgress, Paper } from '@material-ui/core';
import PropTypes from 'prop-types';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { fetchBusinessSalesStart } from '../../../actions/user-actions';
import { DASHBOARD_MACHINE_ID } from '../../../actions/utils';
import { Field, Formik } from 'formik';
import CommonMultiSelectField from '../../common/form/CommonMultiSelectField';
import Box from '@material-ui/core/Box';
import CommonButton from '../../common/CommonButton';
import { Sync } from '@mui/icons-material';
import RenderBreakpoint from '../../common/breakpoints/RenderBreakpoint';

const [MOBILE_BUTTON_HEIGHT, BUTTON_HEIGHT] = [46, 52];

const styles = (theme => ({
  dashboardHeader: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    borderRadius: '2px',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    boxShadow: DASHBOARD_BOX_SHADOW,
    marginBottom: theme.spacing(2.5),
    padding: theme.spacing(3, 3, 3, 2),
    background: theme.palette.type === 'light' ? 'white' : BACKGROUND_DARK,
    border: theme.palette.type === 'light' ? `1px solid ${VERY_LIGHT_GREY_COLOR}` : `1px solid ${BORDER_DARK}`,
    [theme.breakpoints.up('lg')]: {
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
  },
  dashboardText: {
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(1),
    },
    [theme.breakpoints.up('lg')]: {
      alignItems: 'flex-start',
      margin: theme.spacing(0),
      paddingLeft: theme.spacing(2),
    },
  },
  dashboardForm: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'center',
    margin: theme.spacing(1),
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
    },
    [theme.breakpoints.up('md')]: {
      paddingLeft: theme.spacing(2),
      margin: theme.spacing(0),
    },
    '& .MultiSelectField': {
      [theme.breakpoints.down('xs')]: {
        height: MOBILE_BUTTON_HEIGHT,
        margin: 0,
      },
      '& div[class*="selectItem"]': {
        height: '100%',
        [theme.breakpoints.up('sm')]: {
          height: BUTTON_HEIGHT,
        },
      },
    },
    '& button': {
      height: MOBILE_BUTTON_HEIGHT,
      padding: theme.spacing(2),
      fontSize: 15,
      [theme.breakpoints.up('sm')]: {
        height: BUTTON_HEIGHT,
        fontSize: 16,
      },
    },
  },
  salesTitle: {
    fontSize: 14,
    color: GREY_COLOR,
  },
  circularProgress: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    marginRight: 14,
    '& svg': {
      position: 'absolute',
      width: 20,
      height: 20,
    },
  },
}));

const DashboardHeader = ({
                           classes,
                           machinesOptions,
                           setSelectedMachineIds,
                           initialSelectedMachineIds,
                           fetchingStateArray,
                           salesStartTime,
                           fetchBusinessSalesStart,
                         }) => {
  
  const anyApiCallPending = fetchingStateArray.some(call => call);
  
  const handleSubmit = (values) => {
    localStorage.setItem(DASHBOARD_MACHINE_ID, JSON.stringify(values.machineIDs));
    return setSelectedMachineIds(values.machineIDs);
  };
  
  React.useEffect(() => {
    if (!salesStartTime) {
      fetchBusinessSalesStart();
    }
  }, [fetchBusinessSalesStart, salesStartTime]);
  
  return (
    <Paper className={classes.dashboardHeader}>
      <Box className={classes.dashboardText} display={'flex'} flexDirection={'column'} justifyContent={'center'}
           alignItems={'flex-start'}>
        <CardTitle tag="h2">
          <FormattedMessage
            id="page.dashboard.overview"
            defaultMessage="Sales overview"
          />
        </CardTitle>
        {salesStartTime && <h6 className={classes.salesTitle}>
          <FormattedMessage
            id="page.dashboard.info"
            defaultMessage={`Selected start time for the business day: {startTime}`}
            values={{ startTime: salesStartTime?.formattedSalesStartTime }}
          />
        </h6>}
      </Box>
      <Box className={classes.dashboardForm}>
        <Formik
          initialValues={{ machineIDs: initialSelectedMachineIds }}
          onSubmit={(values) => handleSubmit(values)}>
          {({ submitForm }) => {
            return (<>
              <Field
                wide
                name="machineIDs"
                atLeastOneElement
                label={<FormattedMessage id="field.cash.register" defaultMessage="Cash Register" />}
                options={[...machinesOptions]}
                component={CommonMultiSelectField}
                disabled={anyApiCallPending}
                endAdornment={anyApiCallPending && <CircularProgress className={classes.circularProgress} />}
              />
  
              <CommonButton
                isAnimated
                type="submit"
                onClick={() => submitForm()}
                label={<FormattedMessage id="page.dashboard.update" defaultMessage="Update" />}
                disabled={anyApiCallPending}
                endIcon={<RenderBreakpoint desktop>
                  <Sync />
                </RenderBreakpoint>}
              />
            </>);
          }}
        </Formik>

      </Box>
    </Paper>
  );
};

DashboardHeader.propTypes = {
  classes: PropTypes.object,
  machinesOptions: PropTypes.array,
  selectedMachineId: PropTypes.string,
  setSelectedMachineId: PropTypes.func,
  salesStartTime: PropTypes.object,
  fetchBusinessSalesStart: PropTypes.func,
};

const decorate = compose(
  withStyles(styles),
  connect(
    store => ({
      salesStartTime: store.user.salesStartTime,
    }),
    dispatch => bindActionCreators({
      fetchBusinessSalesStart,
    }, dispatch),
  ),
);

export default decorate(DashboardHeader);